
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shippingFAQforwholesalebuyers",
      function () {
        return require("private-next-pages/shippingFAQforwholesalebuyers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shippingFAQforwholesalebuyers"])
      });
    }
  